module.exports = __webpack_public_path__ + "static/Bithumb-a35f469943bfd9b4302cd6da96d7706f.png";